import './_expander-button-block.scss';
import { AnalyticsService } from '../../typescript/common/analytics-service';

(() => {
  if (document.getElementsByClassName('expander-button-block').length === 0) return;

  const elements = document.getElementsByClassName('analytics-tracking-expander-button');
  for (let i = 0; i < elements.length; i += 1) {
    elements[i].addEventListener(
      'click',
      () => {
        if (elements[i].getAttribute('aria-expanded') === 'false') {
          AnalyticsService.addEvent(AnalyticsService.Accordion, 'Klickat på', elements[i].textContent ?? '');
        }
      },
      { once: true }
    );
  }
})();
